import { createContext, type Dispatch, type SetStateAction, useContext } from 'react';
import type { QuickMenuOptions } from '.';

interface QuickMenuContextType {
  quickMenu: QuickMenuOptions | undefined;
  setQuickMenu: Dispatch<SetStateAction<QuickMenuOptions | undefined>>;
}

const defaultState: QuickMenuContextType = {
  quickMenu: undefined,
  setQuickMenu: () => {},
};

export const QuickMenuContext = createContext<QuickMenuContextType>(defaultState);

export const useQuickMenuContext = () => useContext(QuickMenuContext);
